import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-8e8134e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "features-showcase-cta" }
const _hoisted_2 = {
  key: 0,
  class: "features-showcase-cta__teaser"
}
const _hoisted_3 = { class: "features-showcase-cta__description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PxButton = _resolveComponent("PxButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$screen.mdUp)
      ? (_openBlock(), _createElementBlock("h3", _hoisted_2, _toDisplayString(_ctx.$t("selfAssessment.results.featuresShowcase.cta.teaser")), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_PxButton, {
      class: "features-showcase-cta__button",
      size: "large",
      type: "green",
      onClick: _ctx.onClickHandler
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("selfAssessment.results.featuresShowcase.cta.pendingUser.button")), 1)
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.$t(
          "selfAssessment.results.featuresShowcase.cta.pendingUser.description",
        )), 1)
  ]))
}